export default __webpack_public_path__ + "static/self-learn-37ed23c12db23f80bc4887d7bed5603c.webp";